import { Component, ViewChild, TemplateRef, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Cart, UserTypes } from "../_models";
import { BaseComponent } from "../base.component";
import { EventMeshutafComponent } from "../admin/meshutaf/event-meshutaf.component";
import { SelectAreaComponent } from "../admin/components/select-area/select-area.component";

import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import * as $ from "jquery";
import * as _ from "lodash";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { AuthenticationService } from "../_services/authentication.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  templateUrl: "home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent extends BaseComponent {
  @ViewChild("meshutafComp") meshutafComp: EventMeshutafComponent;
  @ViewChild("childContentDiv") childContentDiv: ElementRef;
  @ViewChild("updateChildContent") updateChildContent: TemplateRef<any>;
  @ViewChild("userMessageContent") userMessageContent: TemplateRef<any>;
  public mobileChildrenPanelOpen: boolean = false;
  eventId: number;
  fromModal: boolean;
  childId: number;
  event: any;
  eventMeshutafSelected: any;
  child: any;
  childForEdit: any;
  registeredUser: any;
  docs: any;
  cart: Cart;
  children: any = [];
  allBrothersData: any = [];
  events: any = [];
  eventsMeshutaf: any = [];
  childrenData: any = [];
  collectiveEvents: any = [];
  collectiveNestId: number;
  horeEmpty: boolean = false;
  meshutafView: boolean = false;
  modalInfoReference: any;
  modalDebugInfo: any;
  UserTypesEnum = UserTypes;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    public dataService: DataService,
    private modalService: NgbModal,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  open(childId, eventId) {
    this.router.navigate(["/event/" + childId + "/" + eventId]);
  }

  goToBrothers() {
    this.router.navigate(["/brothers"]);
  }

  childSavedAction(savedChild) {
    const index = _.findIndex(this.children, {
      childId: savedChild.childId,
    });
    if (index >= 0) {
      this.children.splice(index, 1, savedChild);
      this.dataService.children.next(this.children);
      this.modalInfoReference.close();
      this.goToCheckout();
    }
  }

  public goToCheckout() {
    this.childForEdit = undefined;
    if (!_.isEmpty(this.children) && !_.isEmpty(this.cart || this.cart.items)) {
      const childrenIds = _.map(this.cart.items, "item.childId");
      const childrenPurchased = _.filter(this.children, (ch) => {
        return childrenIds.includes(ch.childId);
      });
      childrenPurchased.forEach((child) => {
        if (
          (!this.childForEdit && !child.originCountryChild) ||
          !child.originCountryParent
        ) {
          this.childForEdit = child;
        }
      });
      if (this.childForEdit) {
        const options: NgbModalOptions = {
          windowClass: "modal-childedit-opened",
        };
        this.modalInfoReference = this.modalService.open(
          this.updateChildContent,
          options
        );
      } else {
        this.router.navigate(["/checkout"]);
      }
    }
  }

  public goToAdmin() {
    this.router.navigate(["/admin"]);
  }

  public goToPage(url: string) {
    this.router.navigate(["/" + url]);
  }

  public goHomeMeshutaf() {
    this.eventMeshutafSelected = undefined;
    this.meshutafView = true;
  }

  run() {
    this.loadAllData();

    // if should show popup
    if (
      this.isUserRegular() &&
      !_.isEmpty(this.base.user.popupText) &&
      localStorage.getItem("allowShowPopup")
    ) {
      setTimeout(() => {
        this.modalService.open(this.userMessageContent, {
          windowClass: "modal-usertext-opened",
          backdrop: "static",
        });
      }, 3000);
      localStorage.removeItem("allowShowPopup");
    }
  }

  public getEventAndChild() {
    let found = false;
    if (
      this.children &&
      this.children.length > 0 &&
      this.eventId &&
      this.childId
    ) {
      this.children.forEach((record) => {
        if (
          Number(record.childId) === Number(this.childId) &&
          record.events &&
          record.events.length > 0
        ) {
          this.child = record;
          record.events.forEach((event) => {
            if (Number(event.eventId) === Number(this.eventId)) {
              this.event = event;
              found = true;
            }
          });
        }
      });
    }

    if (!found) {
      this.event = undefined;
      this.child = undefined;
    }
  }

  public toggleCollapseChildren() {
    const chileContent = this.childContentDiv.nativeElement;

    if (chileContent && chileContent.style && chileContent.style.display) {
      this.mobileChildrenPanelOpen = chileContent.style.display === "none";
    } else {
      this.mobileChildrenPanelOpen = true;
    }
    const selector = `#childContent`;
    //mobileChildrenPanelOpen
    $(selector).slideToggle("slow");
  }

  selectEventMeshutaf(event) {
    this.eventMeshutafSelected = event;
    this.meshutafView = false;
  }

  submitCollective(selectArea: SelectAreaComponent) {
    const postData = selectArea.submit();
    if (postData) {
      this.modalInfoReference.close();
      this.collectiveNestId =
        postData && postData["nest"] ? postData["nest"] : undefined;
      //     if (!this.loading){
      // 		 	this.loading = true;
      this.dataService
        .postEntity("collective-events", selectArea.submit())
        .subscribe(
          (data) => {
            //                	this.loading = false;

            this.collectiveEvents = data.events;
          },
          (error) => {
            //                	this.loading = false;
            const body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
          }
        );
      //  		}
    }
  }

  openInfoModal(content, debugInfo) {
    if (debugInfo) {
      this.modalDebugInfo = debugInfo;
      const options: NgbModalOptions = {
        windowClass: "modal-info-opened",
      };
      this.modalInfoReference = this.modalService.open(content, options);
    }
  }

  openModal(content) {
    const options: NgbModalOptions = {
      windowClass: "modal-collective-opened",
    };
    this.modalInfoReference = this.modalService.open(content, options);
  }

  public shouldHideChild(child: any) {
    const events = (child && child.events) || [];
    const hasSomeEventsToDisplay = events.some(
      (event) =>
        !(
          event.isInCart === true ||
          event.isVisible === false ||
          (event.isMihlol === true && event.price <= 0)
        )
    );
    if (hasSomeEventsToDisplay) {
      return false;
    }

    return true;
  }

  private loadAllData() {
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.docs = JSON.parse(localStorage.getItem("docs"));

    const s1 = this.dataService.getUsersData(null).subscribe(
      () => {},
      () => {
        this.authenticationService.logout();
        this.goToPage("login");
      }
    );

    const s2 = this.dataService.cart.subscribe((nextVal) => {
      this.cart = nextVal;
    });

    const s3 = this.dataService.events.subscribe((nextVal) => {
      let isMeshutafData = false;
      if (nextVal && nextVal.length && nextVal.length > 0) {
        isMeshutafData = typeof nextVal[0].childId === "undefined";
      }
      if (this.isUserMeshutaf() && isMeshutafData) {
        this.eventsMeshutaf = nextVal ? nextVal : [];
        this.meshutafView = true;

        if (this.eventMeshutafSelected && this.eventMeshutafSelected.eventId) {
          nextVal.forEach((ev) => {
            if (ev.eventId === this.eventMeshutafSelected.eventId) {
              this.selectEventMeshutaf(ev);
            }
            setTimeout(() => {
              this.meshutafComp.checkAll();
            }, 100);
          });
        }
      } else {
        this.meshutafView = false;
        this.eventsMeshutaf = undefined;
        this.eventMeshutafSelected = undefined;
        this.children = nextVal ? nextVal : [];
        this.getEventAndChild();
      }
    });
    const s4 = this.dataService.children.subscribe((nextVal) => {
      this.allBrothersData = nextVal;
      // Regular Parent (Not rakaz) with no connected children in the system
      this.horeEmpty =
        nextVal &&
        (!nextVal.length || nextVal.length === 0) &&
        this.isUserRegular();
    });
    const s5 = this.activatedRoute.params.subscribe((params) => {
      this.eventId = params["event"];
      this.childId = params["child"];
      this.registeredUser = params["registeredUser"];

      this.getEventAndChild();
    });

    const s6 = this.dataService.registeredUser.subscribe((nextVal) => {
      this.registeredUser = nextVal;
    });

    this.addObservable(s1);
    this.addObservable(s2);
    this.addObservable(s3);
    this.addObservable(s4);
    this.addObservable(s5);
    this.addObservable(s6);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts